import { LinkDownloads } from '../components/LinkDownloads';
import { ConnectedWorkflowArt } from '../components/ConnectedWorkflowArt';
import { useEffect } from 'react';
import { ArrowIcon, MarketingFooter, MarketingHeader } from '../components/MarketingChrome';
import { appPath } from '../lib/config';

export function PaddiqLinkPage() {
  useEffect(() => {
    document.title = 'Paddiq Link — Beta downloads';
  }, []);
  return (
    <div className="marketing-home">
      <a className="mh-skip" href="#main">
        Skip to content
      </a>
      <MarketingHeader />
      <main id="main">
        <section className="mh-link-intro">
          <div className="mh-shell mh-link-intro__grid">
            <div>
              <p className="mh-kicker">Paddiq Link / Beta</p>
              <h1>
                From your MyChron
                <br />
                <span>to Paddiq.</span>
              </h1>
              <p>
                Transfer MyChron sessions over paddock Wi-Fi with the Paddiq Link beta for Mac and
                Windows. Choose the driver, kart, and circuit, then review the runs with your team
                in Paddiq.
              </p>
              <div className="mh-actions">
                <a className="mh-button" href="#download">
                  Beta downloads <ArrowIcon />
                </a>
                <a className="mh-text-link" href={appPath('/login')}>
                  Open Paddiq <ArrowIcon />
                </a>
                <a className="mh-text-link" href="/resources/paddiq-link">
                  Setup and troubleshooting <ArrowIcon />
                </a>
              </div>
              <LinkDownloads />
            </div>
            <ConnectedWorkflowArt />
          </div>
        </section>
        <section className="mh-section">
          <div className="mh-shell">
            <p className="mh-kicker">The beta workflow</p>
            <h2>Connect a logger. Choose sessions. Review the run.</h2>
            <div className="mh-three-columns">
              <article>
                <span className="mh-index">01 / CONNECT</span>
                <h3>Set up your MyChrons.</h3>
                <p>
                  Sign in with your Paddiq account and add each MyChron. Follow the setup options in
                  your installed beta to connect the computer and logger to the same Wi-Fi.
                </p>
              </article>
              <article>
                <span className="mh-index">02 / ORGANIZE</span>
                <h3>Put every run in context.</h3>
                <p>
                  Choose the driver and kart, set the circuit for the day, and review which sessions
                  have been uploaded.
                </p>
              </article>
              <article>
                <span className="mh-index">03 / SYNC</span>
                <h3>Keep the sessions moving.</h3>
                <p>
                  Keep Link running to download the sessions you’ve chosen from connected loggers.
                  Downloaded files wait on your computer until internet access is available for
                  upload.
                </p>
              </article>
            </div>
          </div>
        </section>
        <section className="mh-story">
          <div className="mh-shell mh-story__inner">
            <p className="mh-kicker">Built for your paddock</p>
            <div>
              <h2>Your team. Your network. Your data.</h2>
              <p>
                You’ll need a Paddiq account, a supported MyChron, and a paddock Wi-Fi network that
                lets your computer reach the logger. Internet access is needed to upload sessions to
                Paddiq.
              </p>
              <p>
                Follow the <a href="/resources/paddiq-link">Paddiq Link guide</a> to add your first
                logger, choose sessions, and check uploads. If you already have session files on
                your computer, you can also{' '}
                <a href="/resources/upload-mychron-session">upload them directly in Paddiq</a>.
              </p>
              <p>
                The guides cover saved MyChrons, mesh and guest-network checks, driver assignments,
                circuit selection, session renewal and recovery. Review the features offered by your
                installed build before changing a logger’s settings.
              </p>
              <a className="mh-text-link mh-text-link--purple" href="/support">
                Talk to us about your setup <ArrowIcon />
              </a>
            </div>
          </div>
        </section>
      </main>
      <MarketingFooter />
    </div>
  );
}
